import type { Professor } from "@/types"

const KEYS = {
  access: "platonica_access",
  refresh: "platonica_refresh",
  professor: "platonica_professor",
} as const

export const authStorage = {
  getAccess: () => localStorage.getItem(KEYS.access),
  getRefresh: () => localStorage.getItem(KEYS.refresh),
  getProfessor: (): Professor | null => {
    const raw = localStorage.getItem(KEYS.professor)
    if (!raw) return null
    try {
      return JSON.parse(raw) as Professor
    } catch {
      return null
    }
  },
  set: ({
    access,
    refresh,
    professor,
  }: {
    access: string
    refresh: string
    professor: Professor
  }) => {
    localStorage.setItem(KEYS.access, access)
    localStorage.setItem(KEYS.refresh, refresh)
    localStorage.setItem(KEYS.professor, JSON.stringify(professor))
  },
  setAccess: (access: string) => localStorage.setItem(KEYS.access, access),
  // The server rotates the refresh token on every refresh (api/auth.py::rotate_refresh).
  setRefresh: (refresh: string) => localStorage.setItem(KEYS.refresh, refresh),
  updateProfessor: (professor: Professor) =>
    localStorage.setItem(KEYS.professor, JSON.stringify(professor)),
  clear: () => {
    localStorage.removeItem(KEYS.access)
    localStorage.removeItem(KEYS.refresh)
    localStorage.removeItem(KEYS.professor)
  },
}
